'use strict';
import categoryCommon from "./categoryCommon";

/**
 * Everything specific to the category leaf layout.
 * @namespace
 */
var responsiveCatLeaf = {
	/**
	 * Initialize the product list.
	 * @returns {undefined}
	 */
	init: function() {
		// Register the event tracking first.
		categoryCommon.init();
		this.eventTracking();
	},
	/**
	 * Category leaf page event tracking.
	 * @returns {undefined}
	 */
	eventTracking: function() {
		$(document.body).on('click', '.relatedCategoryName', function() {
			let categoryIdentifier = $('.categoryIdentifier').val().replaceAll('"', '-inch'),
				relatedCategoryEventLabel = $(this).attr('title').replaceAll('"', '-inch');

			ga('send', 'event', categoryIdentifier, 'Related Categories', relatedCategoryEventLabel);

		});
	}
};

// DOM ready
$(function() {
	responsiveCatLeaf.init();
});